import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
import chart from './chart';
import * as d3 from 'd3';

export default {
  props: {
    value: PigeonDocNodeModel,
  },
  mounted() {
    if (this.$refs['chart']) {
      this.createChart();
      window.addEventListener('resize', () => {
        clearTimeout(this.windowResizeTimeout);
        this.windowResizeTimeout = setTimeout(() => {
          d3.select(this.$refs['chart']).selectAll('*').remove();
          this.createChart();
        }, 1000);
      });
    }
  },
  methods: {
    createChart() {
      if (this.$refs['chart']) {
        chart.create(this.$refs['chart'], this.value.content.data, {
          primaryColour: this.value.meta.primaryBarColour,
          highlightColour: this.value.meta.highlightBarColour,
          axisLabels: this.value.meta.axisLabels,
          axisHoverText: this.value.meta.axisHoverText,
          scoreCutoff: this.value.meta.scoreCutoff,
          suffix: this.value.meta.suffix,
          performanceMode: this.value.meta.performanceMode,
          minimalMode: this.value.meta.minimalMode,
        });
      }
    },
  },
};
